import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import Squares from './Squares';
import RecentWorkLink from './RecentWorkLink';
import HomeWelcome from './HomeWelcome';
import RecentWorkContainer from './RecentWork/RecentWorkContainer';

const HomeContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
`;

const TopDiv = styled.div`
  margin-top: 0;
  height: 0;
  width: 0;
`;

// const FooterContainer = styled.div`
//   margin-top: ${() => (isMobile ? '620px' : '900px')};
//   width: 100%;
//   bottom: 0;
// `;

const Home = () => {
  const [visible, setVisible] = useState(false);

  function scrollWork() {
    const currentScrollY = window.pageYOffset;

    if (currentScrollY >= 1) {
      setVisible(true);
    }
  }

  const linkOnClick = () => {
    setVisible(true);
  };

  useEffect(() => {
    window.addEventListener('scroll', scrollWork);

    // Remove listener (like componentWillUnmount)
    return () => {
      window.removeEventListener('scroll', scrollWork);
    };
  });

  return (
      <HomeContainer>
        <TopDiv id="home" />
        <Squares />
        <HomeWelcome />
        <RecentWorkLink visible={visible} linkOnClick={linkOnClick} />
        <RecentWorkContainer visible={visible}></RecentWorkContainer>
      </HomeContainer>
  );
};

export default Home;
